import "./App.scss";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import Layout from "./Layout";
import MainPage from "./pages/main-page";
import { OilPaintingExample } from "./pages/oil-painting/oil-painting-example.jsx";
import { SpotlightCardsExample } from "./pages/spotlight-cards/spotlight-cards-example.jsx";
import GazeTrailCanvas from "./pages/gaze-trail/gaze-trail.jsx";
import InteractiveNodesCanvas from "./pages/interactive-nodes/interactive-nodes.jsx";
import PracticePage from "./pages/practice/practice.jsx";
import { useDarkMode } from "./hooks/useDarkMode.js";
import "tdbrowse-web-components";

const isPracticeSubdomain = window.location.hostname.startsWith("practice.");

function App() {
  const isDarkMode = useDarkMode();
  useEffect(() => document.documentElement.setAttribute("data-bs-theme", isDarkMode ? "dark" : "light"), [isDarkMode]);

  return (
    <BrowserRouter>
      <Routes>
        {isPracticeSubdomain ? (
          <Route path="/" element={<PracticePage />} />
        ) : (
          <>
        <Route path="/practice" element={<PracticePage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<MainPage />} />
          <Route path="oil-painting" element={<OilPaintingExample />} />
          <Route path="spotlight-cards" element={<SpotlightCardsExample />} />
          <Route path="gaze-trail" element={<GazeTrailCanvas />} />
          <Route path="interactive-nodes" element={<InteractiveNodesCanvas />} />
        </Route>
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
